import {
  deleteContractDocument,
  clearContractDocumentAction,
} from 'actions/contracts/contractDocumentActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractDocumentDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractDocumentAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractDocument(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract document? This can not be
        undone.
      </div>
    </form>
  )
}

export default ContractDocumentDelete
